import { DONATOR_LIST, DONATOR_ADDEDIT, DONATOR_CHANGE_STATUS, DONATOR_DELETE, DONATOR_EXPORT } from "../../api/constApi";
import { authHeader } from "./authHeader";
import { apiInstance } from "./axiosApi";


export const donatorsListApi = (payload) => {
    return apiInstance.post(DONATOR_LIST, payload, {
        headers: authHeader(),
    });
};

export const donatorsChangeStatusApi = (payload) => {
    return apiInstance.post(DONATOR_CHANGE_STATUS, payload, {
        headers: authHeader(),
    });
};

export const AddEditDonatorsApi = (payload) => {
    return apiInstance.post(DONATOR_ADDEDIT, payload, {
        headers: authHeader(),
    });
};

export const donatorDeleteApi = (payload) => {
    return apiInstance.post(DONATOR_DELETE, payload, {
        headers: authHeader(),
    });
};

export const donatorExportApi = (payload) => {
    return apiInstance.post(DONATOR_EXPORT, payload, {
        headers: authHeader(),
    });
};